import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/FloatingRoleButtons.css';

const FloatingRoleButtons = ({ isAdmin, isTutor }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const forcedSidebarMode = searchParams.get('sidebar');
  const isTutorWorkspace = location.pathname.startsWith('/tutor/workspace');
  const isTutorShell = forcedSidebarMode === 'tutor' || isTutorWorkspace;
  const languageFromPath = (() => {
    const match = location.pathname.match(/^\/tutor\/workspace\/([^/]+)/);
    return match?.[1] || '';
  })();
  const activeTutorLanguage = searchParams.get('lang') || languageFromPath;

  const withSidebarContext = (basePath) => {
    const [pathname, existingQuery = ''] = String(basePath || '').split('?');
    const merged = new URLSearchParams(existingQuery);
    const params = new URLSearchParams();
    params.set('sidebar', isTutorShell ? 'tutor' : 'student');
    if (isTutorShell && activeTutorLanguage) {
      params.set('lang', activeTutorLanguage);
    }
    params.forEach((value, key) => {
      merged.set(key, value);
    });
    const query = merged.toString();
    return query ? `${pathname}?${query}` : pathname;
  };

  // 如果都不是角色且不在工作區，則不渲染任何東西
  if (!isAdmin && !isTutor && !isTutorShell) return null;

  return (
    <div className="floating-role-buttons-container">
      {/* Back to Student Mode (Only in Workspace) */}
      {isTutorShell && (
        <button 
          className="floating-role-btn student-mode-btn" 
          onClick={() => navigate('/introduction?sidebar=student')} 
          title="Back to Student Mode"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </button>
      )}

      {/* Tutor Button (Only if Tutor) - always visible if isTutor, stacked below if both exist */}
      {isTutor && (
        <button 
          className="floating-role-btn tutor-btn" 
          onClick={() => navigate(withSidebarContext('/tutor-dashboard'))}
          title="Tutor Dashboard"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
          </svg>
        </button>
      )}

      {/* Admin Button (下方) */}
      {isAdmin && (
        <button 
          className="floating-role-btn admin-btn" 
          onClick={() => {
            const savedTab = localStorage.getItem('last_active_tab_admin');
            const base = savedTab ? `/admin?tab=${encodeURIComponent(savedTab)}` : '/admin';
            const next = withSidebarContext(base);
            navigate(next);
          }}
          title="Admin Panel"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </button>
      )}
    </div>
  );
};

export default FloatingRoleButtons;
